import {Poi} from '../../react-app-env';
import React from 'react';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import {i18n} from '../../i18n/i18n';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import {PoiMetaData} from '../../services/MetaDataService';
import {Events, EventType} from '../../events/Events';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';
import {useReadonly} from '../context/ReadonlyContext';
import {ifFalse} from '../../utils/Utils';

export interface LocationGroupProps {
  poi: Poi;
  metaData?: PoiMetaData | null;
  onRouteEffectClicked: () => void;
}

const LocationGroup: React.FunctionComponent<LocationGroupProps> = ({ poi, metaData, onRouteEffectClicked }) => {
  const readonly = useReadonly();
  const ifWriteAccess = ifFalse(readonly);

  const formattedAddress = metaData?.address ?? (poi.location.lat + ', ' + poi.location.lng);

  /**
   * Copies the formatted address to the clipboard and shows a confirmation message.
   */
  async function copyFormattedAddressToClipboard() {
    await navigator.clipboard.writeText(formattedAddress);
    Events.publish(EventType.COPY_TO_CLIPBOARD_NOTIFICATION, i18n().poiDetails.location.copyAddressConfirmation);
  }

  let routeLabel = i18n().routeEffects.none.label;
  if (poi.routeEffect === 'CONTINUE') {
    routeLabel = i18n().routeEffects.continue.label;
  } else if (poi.routeEffect === 'RESTART') {
    routeLabel = i18n().routeEffects.restart.label;
  }

  return <ListViewGroup>
    <ListViewItem title={formattedAddress}
                  iconCategory="fa-map-pin"
                  decoration={DefaultItemDecorations.COPY}
                  onClick={() => copyFormattedAddressToClipboard()}/>
    {ifWriteAccess(
        <ListViewItem title={routeLabel}
                      iconCategory="fa-route"
                      decoration={DefaultItemDecorations.CHEVRON}
                      onClick={() => onRouteEffectClicked()}/>
    )}
    <ListViewItem title={i18n().poiDetails.location.centerInMap}
                  iconCategory="fa-bullseye"
                  onClick={() => Events.publish(EventType.CENTER_IN_MAP, poi.location)}/>
  </ListViewGroup>;
};

export default LocationGroup;
